"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M16 1H2v16h2V3h12zm5 4H6v18h15zm-2 16H8V7h11z"
}), 'ContentCopySharp');